import { useContext } from 'react';
import { ConfigContext } from 'src/components/AppShell/ConfigProvider';

export const useHolidaysAndBlackDays = () => {
    const { blackoutDays } = useContext(ConfigContext);

    const computedBlackoutDays =
        blackoutDays &&
        Object.values(blackoutDays).map((blackoutDay) => {
            const datePart = blackoutDay.blackout_date.split(' ')[0];
            const [year, month, day] = datePart.split('-').map(Number);
            // Create dates in local timezone to match how currentDate is created in calculateDays
            const basicDate = new Date(year, month - 1, day, 0, 0, 0, 0);
            const nextDay = new Date(year, month - 1, day + 1, 0, 0, 0, 0);
            return {
                date: `${datePart} 00:00:00`,
                start: basicDate,
                end: nextDay,
                name: 'Blackout Day',
                type: 'public',
                rule: 'rule',
            };
        });

    const filteredGBHolidaysAndBlackDays = computedBlackoutDays?.filter(
        (value, index, self) => index === self.findIndex((t) => t.date === value.date),
    );

    return {
        GBHolidaysAndBlackDays: computedBlackoutDays || [],
        filteredGBHolidaysAndBlackDays: filteredGBHolidaysAndBlackDays || [],
    };
};
